var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    style: `height:${_vm.SVG_RENDER_HEIGHT}px`,
    attrs: { id: _vm.rootElementId },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }